import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('sales-completions-approve', storeModule.createStoreModule('sales-completions-approve'))
